import { useQuery } from '@tanstack/react-query';
import { getEmployeesApi } from 'api/views';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

type PeopleProps = {
  designation?: string;
  displayName: string;
  id: number;
  profilePhoto: string;
  email: string;
  employeeFunction?: string;
};

export const usePeople = ({ cohortId, module }) =>
  useQuery(
    [REACT_QUERY_KEYS.views.employees, module, cohortId],
    () =>
      getEmployeesApi({
        moduleType: module,
        cohortId,
      }).then((res) => res.entity as PeopleProps[]),
    { enabled: !!module && cohortId !== null && cohortId !== undefined }
  );
